import { Button, Modal } from "antd";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteTag } from "../../redux/tags-slice";
import { formatDate } from "../../utils/date";
import { AgGrid } from "../ag-grid";
import { CreateTag } from "./create-tag";
import styles from "./index.module.css";

export const Tags = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const tags = useSelector((state) => state.tags);
  const tagCategories = useSelector((state) => state.tagCategories);
  const dispatch = useDispatch();

  return (
    <div className={styles.container}>
      <Button type="primary" onClick={() => setIsModalOpen(true)}>
        Tags
      </Button>

      <Modal width="50%" open={isModalOpen} title="Tags" footer={null} onCancel={() => setIsModalOpen(false)}>
        <AgGrid
          className={styles.grid}
          rowData={tags}
          columnDefs={[
            {
              headerName: "Tag",
              field: "label",
            },
            {
              headerName: "Category",
              field: "category",
              refData: Object.fromEntries(tagCategories.map(({ value, label }) => [value, label])),
            },
            {
              headerName: "Created On",
              field: "createdOn",
              valueFormatter: ({ value }) => formatDate(value),
            },
            {
              headerName: "Actions",
              field: "value",
              cellRenderer: ({ value }) => (
                <Button danger onClick={() => dispatch(deleteTag(value))}>
                  Delete
                </Button>
              ),
            },
          ]}
        />
        <CreateTag />
      </Modal>
    </div>
  );
};
